module.exports = __webpack_public_path__ + "media/budapest/small_bastion-a1740da4.jpg";